import React from 'react';
import { CtaButton } from '../CtaButton';
export function Guarantee() {
  return <section className="w-full bg-bone px-4 py-14 sm:px-6 sm:py-20" data-id="element-191" data-mp="20ld5zg0iu7l3">
      <div className="mx-auto w-full max-w-2xl" data-id="element-192" data-mp="20jilg2t5whhj">
        <div className="rounded-2xl bg-white p-6 text-center shadow-card ring-1 ring-ink/[0.08] sm:p-9" data-id="element-193" data-mp="24mycmjmgppmu">
          <span aria-hidden="true" className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-blood/10 text-3xl" data-id="element-194" data-mp="29eykcy8rxmtz">
            🛡️
          </span>
          <h2 className="mt-5 font-display text-[24px] font-extrabold leading-tight text-ink sm:text-3xl" data-id="element-195" data-mp="2jb1na6bg9phz">
            7-day satisfaction guarantee
          </h2>
          <p className="mt-3 text-sm font-extrabold uppercase tracking-[0.14em] text-blood" data-id="element-196" data-mp="2scstdc9wjycd">
            The risk is completely ours
          </p>

          <p className="mt-5 text-[15px] leading-relaxed text-graphite/80 sm:text-base" data-id="element-197" data-mp="tyhl14rcq2so">
            Review it. Use it. Compare it with the way you currently make
            clinical decisions.
          </p>
          <p className="mt-4 text-[15px] leading-relaxed text-graphite/80 sm:text-base" data-id="element-198" data-mp="3smzpp6g6hm06">
            If within the next 7 days you feel that Hypertension Route doesn’t
            give you the clarity, speed and confidence we promised, simply
            contact us and we’ll refund{' '}
            <strong className="font-bold text-ink" data-id="element-199" data-mp="3dxv55ilwv5ow">100% of your purchase</strong>
            .
          </p>
          <p className="mt-4 text-[14px] font-semibold leading-relaxed text-graphite/70" data-id="element-200" data-mp="feelgaif8o6t">
            No endless forms. No uncomfortable explanations. No fine print.
          </p>

          <div className="mt-8 flex justify-center" data-id="element-201" data-mp="5fp8mw5dttxf">
            <CtaButton label="I want to try it risk-free" data-id="element-202" data-mp="hnumpmtckst" />
          </div>
        </div>
      </div>
    </section>;
}